import { Component} from '@angular/core';
import { AppModule } from '../app.module';
import { RouterOutlet, RouterLink, Router } from '@angular/router';
import { SharedDataService } from '../shared/shareddata.service';
import { SocketMessage, SocketMessageType } from '../models/websocket';
import { Globals } from '../shared/globals';
import { Whatsapp } from "../whatsapp/whatsapp";
import { AuthService } from '../auth.service';
import { WhatsappService } from '../whatsapp/whatsapp.service';
import { Incident, IncidentSearchRequest } from '../models/incident';
import { IncidentService } from '../shared/incident.service';
import { NotificationService } from '../shared/notification.service';
import { Stats } from '../dash/stats/stats';


@Component({
  selector: 'app-main-layout',
  imports: [AppModule, RouterOutlet, RouterLink, Whatsapp, Stats],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.less'
})




export class MainLayout{

  constructor(
      public sharedDataService: SharedDataService,
      private router: Router,
      public authService: AuthService,
      public whatsappService: WhatsappService,
      private incidentService: IncidentService,
      private notification: NotificationService
    ) { }

  public isSiderCollapsed: boolean = false;
  public socketMessageType = SocketMessageType;
  public appVersion = Globals.Constants.VERSION_NUMBER;
  
  private selectedWhatsappMessageId: number;

  public onCloseWhatsAppDrawer(): void {
    this.sharedDataService.isWhatsappDrawerVisible = false;
  }

  public onWhatsappOpenedFromStats(): void {
    this.isSiderCollapsed = true;
  }

  public onSelectCallcentreOperator(): void {
    this.sharedDataService.requestCallcentreOperatorSelection();
  }

  public onClickLogout(): void {
    this.authService.removeStoredLogin();
    this.router.navigate(['/login']);
  }

  // public onClickCreateNewIncident(msg: SocketMessage) {
  //   this.sharedDataService.selectedMessage = this.sharedDataService.messageAsObject(msg);
  //   this.sharedDataService.isWhatsappDrawerVisible = false;
  //   this.router.navigate(['/incident/new']);
  // }

  // public onClickAddToIncident(msg: SocketMessage) {
  //   this.isSearchForIncidentModalVisible = true;
  //   this.selectedWhatsappMessageId = this.sharedDataService.messageAsObject(msg).whatsappMessageId;
  //   this.incidentSearchRequest = {
  //     closedIncidents: false,
  //     startDate: '',
  //     endDate: '',
  //     incidentNumber: ''
  //   };
  //   this.onSearchIncident();
  // }

  


  


  

}
